// PRODUCT SECTION ********************************          
$(window).on("load", function() {                                                                                                                                                               



   // if not inner product page , redirect to collection
   if (window.location.pathname === "/products" || window.location.pathname === "/products/") { window.location.href = "https://smushballs.com/collections"; }  



   // set product content position ***
   $(window).on("resize", function() {

      var contSec = $("#FeaturedContent"); 
      contSec.css({"top": "calc(50% - " + ((contSec.height() / 2) + 10) + "px"});  

   }).resize();



});








// FEATURED PRODUCT CAROUSEL SECTION ********************************          
$(window).on("load", function() {                                                                                                                 



   // globals ***
   var done = true,
       thumbnailCarPosition = 0,
       featThumbDistance,
       featCarMaxIndex,
       currentFeaturedQty = 1;


   
   // ******************
   // CAROUSEL
   // ******************



   // display first image ***
   $("#FeaturedSection #FeaturedImg .fimg.fi1").css({"display":"block"});  



   // set variables on resize *** 
   $(window).on("resize", function() {  

      var fcsWidth = $("#FeaturedSection").css("width"),
          fcontWidth = $("#FeaturedContent").css("width");   

      // desktop
      if (fcsWidth === "1250px" || fcsWidth === "1000px") {
        featThumbDistance = 110;
        featCarMaxIndex = 3;
      } 

      // smaller desktop - mobile
      if (fcsWidth === "821px" || fcsWidth === "500px" || fcontWidth === "330px") {        
        featThumbDistance = 90;
        featCarMaxIndex = 4;    
      } 

   }).resize();



   // control active thumbnail / featured image *** 
   $("#FeaturedImgControls .fcontrol").click(function() {

       if (!($(this).hasClass("active")) && done) { 

           doneUtil();

           // active thumbnail
           $("#FeaturedImgControls .fcontrol.active").removeClass("active");
           $(this).addClass("active"); 
           
           // save thumbnail num
           var activeCarNum = $(this).attr("data-num");  

           // hide current img
           $("#FeaturedImg .fimg.active").removeClass("active") 
           setTimeout(function() { $("#FeaturedImg .fimg.active").css({"display":"none"}); }, 510); 

           // display new img
           setTimeout(function() {
              $("#FeaturedImg .fimg.fi" + activeCarNum).css({"display":"block"});
              setTimeout(function() { $("#FeaturedImg .fimg.fi" + activeCarNum).addClass("active"); }, 20);
           }, 515);

       }

   });  



   // control thumbnail carousel ***
   $("#FeaturedImgControls .fcarrow").click(function() {

      // up
      if ($(this).hasClass("one") && (thumbnailCarPosition > 0)) {
         thumbnailCarPosition--; 
         moveThumbnailCarousel(); 
      }

      // down 
      if ($(this).hasClass("two") && (thumbnailCarPosition < featCarMaxIndex)) {
         thumbnailCarPosition++; 
         moveThumbnailCarousel();
      }

   });

   

   // move thumbnails ***
   function moveThumbnailCarousel() {
      $("#FeaturedControlsCarouselInner").css({"top": ((thumbnailCarPosition * featThumbDistance) * -1)  });
   }



   // ******************
   // PRODUCT INFO AREA
   // ******************



   // set first variant as active , if variants exist ***   
   var firstAvailableVariant = $(".btns.two h5.fqty.v").first();

   if (!(firstAvailableVariant.attr("data-variantprice") === undefined)) {
      firstAvailableVariant.addClass("active");    
      $("#FeaturedContent h3").html(firstAvailableVariant.attr("data-variantprice") + " <span>Free Shipping & 30 Day Money Back Guarantee</span>");
   } 
   else {
      console.log("No variants exist.");      
   }



   // change item or variant quantity ***  
   $(".btns .fqty").click(function() {  

      var qtySpan = $("#FeaturedQuantity span.qty"); 

      if ($(this).hasClass("plus")) {
         currentFeaturedQty++;
         qtySpan.text(currentFeaturedQty);  
      }

      if ($(this).hasClass("minus") && currentFeaturedQty > 1) { 
         currentFeaturedQty--;
         qtySpan.text(currentFeaturedQty);   
      }

      if ($(this).hasClass("v")) {
         $(".btns.two .fqty.active").removeClass("active");
         $(this).addClass("active");  
         $("#FeaturedContent h3").html($(this).attr("data-variantprice") + " <span>Free Shipping & 30 Day Money Back Guarantee</span>");          
      }

   });   



   // ******************
   // UTILITIES
   // ******************



   // done util ***
   function doneUtil() {
      done = false;
      setTimeout(function() { done = true; }, 1100);
   }



});



 




// DESCRIPTION SECTION ********************************          
$(window).on("load", function() {                  



   // faq click function ***
   $("#DescriptionSection .faq").click(function() { 
      
      if (!$(this).hasClass("acitve")) { 
         
         var pheight = $(this).find(".faqbody p").height();

         $("#DescriptionSection .faq.active .faqbody").css({"height": 0 });
         $("#DescriptionSection .faq.active").find("h3 span.open").text("+");
         $("#DescriptionSection .faq.active").removeClass("active");

         $(this).addClass("active").find("h3 span.open").text("-");
         $("#DescriptionSection .faq.active .faqbody").css({"height": pheight + 18 }); 

      }

   });



   // open first faq ***
   $("#DescriptionSection .faq.first").click(); 



});  








// GALLERY SECTION ********************************  
$(window).on("load", function() {                       



   // globals ***
   var done = true,
       galleryImgWidth,
       galleryCarPosition = 0,
       galleryImgWidthFactor,
       galleryImgWidthOffset,
       galleryCarMaxIndex;



   // set carousel variables  &  convert to grid layout in mobile *** 
   $(window).on("resize", function() {  
      
      var gsHeight = $("#GallerySection").css("height");     

      // viewport > 550
      if (gsHeight === "600px" || gsHeight === "500px" || gsHeight === "400px") {
        galleryImgWidthFactor = 0.50;
        galleryImgWidthOffset = 8 / 3;  
        galleryCarMaxIndex = 1;
      } 

      // viewport < 550
      if (gsHeight === "300px") {  
        galleryImgWidthFactor = 1;
        galleryImgWidthOffset = 0;
        galleryCarMaxIndex = 2;   
      }  

      galleryImgWidth = ($("#GalleryCarousel").width() * galleryImgWidthFactor) - galleryImgWidthOffset;   

      $("#GalleryCarouselInner .galleryimg").css({"width": galleryImgWidth });

      $("#GalleryCarouselInner").css({"width": (galleryImgWidth * 3) + 8 });    

      resetGalleryCar(); 

   }).resize();



   // controls *** 
   $("#GallerySection .gallerycontrol").click(function() { 

       if (done) { 

          doneUtil(); 

          // left 
          if ($(this).hasClass("left") && (galleryCarPosition > 0)) {
             galleryCarPosition--; 
             moveGalleryCarousel(); 
          }

          // right
          if ($(this).hasClass("right") && (galleryCarPosition < galleryCarMaxIndex)) {
             galleryCarPosition++; 
             moveGalleryCarousel();
          }

       }

   });  
   


   // move gallery ***
   function moveGalleryCarousel() {  
      $("#GalleryCarouselInner").css({"left": (((galleryImgWidth * galleryCarPosition) + (4 * galleryCarPosition)) * -1)  }); 
   }



   // reset carousel *** 
   function resetGalleryCar() {
      $("#GalleryCarouselInner").css({"left":"0px"});  
      galleryCarPosition = 0; 
   }



   // done util *** 
   function doneUtil() {
      done = false;
      setTimeout(function() { done = true; }, 1000);
   }



});








// MODAL SECTION ********************************       
$(document).ready(function() {            


   // init *********
   var modal = $("#Modal"),
       num, 
       done = true,
       data = [
          {
            h1: "Before Games",
            p: "Many schools and fields do not have many batting cages. So prior to a game during warmups, make six piles of smushballs (40 in each pile if you purchased a case) and have six players throw to six hitters and the rest of the team can shag balls. Once finished, make the piles again and rotate so six more players now become hitters. Then when finished, rotate again. In literally 15-20 minutes, the entire team has had 40 swings to get warmed and focused."
          },
          {
            h1: "Placing Drill",
            p: "Player throws from his knees five yards away from the batter over a plate. Do not have the players lob the ball, but rather throw it softly waist high. Have batters learn to place the ball by hitting throws that are inside and outside."
          },
          {
            h1: "Speed Drill",
            p: "Player stands 5 to ten yards from the batter and throws overhand and gradually throws harder and harder. Mix up throws with variations including throwing sidearm, changeups and fastballs."
          },
          {
            h1: "Soft Toss",
            p: "Use any fence and have the player kneel and toss a ball whereas the batter can then hit into the fence.Younger players can also hit off of a tee into a fence. The faster and harder the swing, the more power the Smush ball will have and it can stick in the fence or go through. No damage is done to anything. A variation is to have a point system..ie 1 point for hitting the ball, two points for sticking it in the fence and 5 points to hit the ball through the fence."
          },
          {
            h1: "Best of The Best",
            p: "Here you have all the boys compete and the coach throws one at a time over the strike zone and try to get the batter to miss. The object is for the batter to see how many in a row they can hit. Once they swing and miss, a new batter begins. Indoor placement – In a gym, have the batter stand underneath one of the baskets. The person throwing throws from the free throw line.Have targets for the batter to aim at. Points can be used to see who does the best. One point for hitting, two points to hit it past the oppositefree throw line. Five points to hit the opposite wall and five points in hitting specific targets.(chairs, backboard etc)."
          },
          {
            h1: "Eye Focus",
            p: "Mark balls with a round spot the size of a quarter. Give some balls a red spot, some a black spot, some a green. As the ball is thrown to the batter, have him call out the color as he swings and hits."
          },
          {
            h1: "For Catchers",
            p: "You can also use these balls for blocking drills for catchers, indoor or outdoor."
          },
          {
            h1: "For Pitchers",
            p: "Work on proper release positions or loosen arms and shoulders without tiring the arm."
          }
       ];
       


   // open modal ********* 
   $("#DrillSection .col").click(function() {

      if (done) {

         done = false;  
         num = $(this).attr("data-num");  
         openModal();
         
      }

   }); 
   


   // close modal *********
   $(".modalsection .close").click(function() {

      if (!done) {

         modal.css({"opacity":"0","transform":"scale(0.9)"});
         setTimeout(function() {
            modal.css({"display":"none"});
            done = true;    
         }, 1000);

      }

   });



   // modal open *********  
   function openModal() {

      modal.css({"display":"block"});
      modal.find("h1").html(data[num - 1].h1);
      modal.find("p").html(data[num - 1].p);

      setTimeout(function() {  
         modal.css({"height": 155 + modal.find(".contentinner").height() });     
         setTimeout(function() {
            modal.css({"opacity":"1","transform":"scale(1)"});   
         }, 50);
      }, 50);

   }

   $(window).on("resize", function() { modal.css({"height": 155 + modal.find(".contentinner").height() }); });  



});








// MISSION SECTION ********************************          
$(window).on("load", function() {                                                                             


    $(window).resize(function() {

      if ($("#MissionSection .col").css("float") === "none") {
         
         var contHeight = $("#MissionSection .col.content .continner").height();

         $("#MissionSection .col.content").css({"height": contHeight + 65});      

         $("#MissionSection").css({"height": $("#MissionSection .col.content").height() + 300});

      }

      if ($("#MissionSection .col").css("float") === "left") {
         $("#MissionSection, #MissionSection .col.content").removeAttr("style");  
      }

    }).resize();


});     






